import _jsx from "@babel/runtime/helpers/jsx";
var _Label;
import React from 'react';
import { Glyphicon, Label, Text } from 'reaxl';

/**
 *  Renders an incentive badge for vehicles with special offers
 */
function IncentiveBadge() {
  return _Label || (_Label = /*#__PURE__*/_jsx(Label, {
    bsStyle: "secondary",
    "data-cmp": "IncentiveBadge"
  }, void 0, /*#__PURE__*/_jsx(Text, {
    "verical-align": "baseline"
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    className: "margin-right-1",
    glyph: "usd-circle"
  })), /*#__PURE__*/_jsx(Text, {
    "verical-align": "baseline"
  }, void 0, "Incentive")));
}
export default IncentiveBadge;